import { reactive ,ref} from "vue";
export const orderData = reactive({
    cartList: [],
    sumCartPrice: 0,
    sumCartCount: 0,
    customer: {},
    customerType: 1
})

export const stateReloadCustomer = ref(false)

export const stateCategoryList = ref([]);

export const stateWorkWeiXinUser = reactive({
    external_userid: '',
    name: '',
    avatarUrl: '',
    unionid: ''

})

export const stateCustomer = reactive({
    _id: '',
    avatarUrl: '',
    name: '',
    mobile: '',
    sum: {
        order: 0,
        cika: 0,
        discount: 0,
        coupon: 0,
        follow: 0
    },
    point: 0,
    storeAmount: 0,
    zengAmount: 0,
    totalConsumAmount: 0,
    unionid: '',
    consultant: '',
    lastConsumAt: '',
    createAt: { time3: '' }
})

export const stateUser = reactive({
    _id:''

})

export const stateShop = reactive({ _id: '1b9686ec67fb66a10105d0836028b2ea' })